// Packages
import PropTypes from 'prop-types'

// Components
import CouponForm from 'modules/Coupons/components/Form';

// Other
import useApi from 'hooks/useApi';

const CouponCreateScreen = ({ onClose, onSubmit }) => {

    const { post: createItem, errors } = useApi('/coupons',  false)

	const submit = async (values) => {

        if( await createItem(values, 'Coupon created!') ) {
    
            onSubmit();
        }
    }


    return(
        <CouponForm 
            errors={errors} 
            onClose={onClose} 
            onSubmit={submit} 
            type='create' 
        />
    )
}

CouponCreateScreen.propTypes = {
	onClose: PropTypes.func,
	onSubmit: PropTypes.func,
}

CouponCreateScreen.defaultProps = {
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')}
}

export default CouponCreateScreen;